/* URSA Test It Kit upsell (URSA custom, 13 Oct 2026).
   1. Supercart basket drawer: "Never used URSA before?" card under the basket items, above "You may also like" (and in the empty basket).
   2. /cart page: same card under the items (rendered in Liquid since 20 Oct, W26; this script wires its button).
   3. Homepage band (sections/ursa-test-it-kit.liquid): one-click add, then opens the basket.
   Hidden when the kit is already in the basket, and for logged-in customers who have ordered before.
   Config comes from window.URSA_TIK (set in layout/theme.liquid). To remove: delete the Test It Kit lines in layout/theme.liquid. */
(function () {
  'use strict';
  var C = window.URSA_TIK; if (!C || !C.id) return;
  var inCart = false, busy = false;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hasKit(cart) { return !!(cart && cart.items && cart.items.some(function (i) { return i.variant_id === C.id || i.id === C.id; })); }
  function readCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { inCart = hasKit(c); return c; }).catch(function () { return null; }); }
  function showCard() { return !C.returning && !inCart; }
  /* 19 Oct 2026 (Sam): the card copies the look of the 'Basket deal' tape offer above it (pill + headline, white inner card,
     price then struck-through compare-at price, 'Add to cart'), so the two read as one family. Values mirror the .utk-offer rules in ursa-glass.js. */
  function priceHTML() { return '<strong>' + esc(C.price) + '</strong>' + (C.compare ? ' <s><span class="utk-vh">was </span>' + esc(C.compare) + '</s>' : ''); }
  function btnLabel() { return 'Add to basket'; }

  function add() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: C.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); inCart = true; if (typeof window.updateSupercart === 'function') window.updateSupercart(); syncAll(); return true; })
      .catch(function () { return false; })
      .finally(function () { busy = false; });
  }
  function openBasket() {
    var a = document.querySelector('#header-group a[href="/cart"], header a[href="/cart"]');
    if (a) a.click(); else location.href = '/cart';
  }

  /* ---------- card look (shared by the drawer and the /cart page) ---------- */
  function cardCSS(c, pre) { // c = card class, pre = scope prefix: Supercart's reset (Tailwind preflight) beats plain class rules, as it does for the tape card's #supercart rules
    return [
      pre + '.' + c + ' { margin: 16px 16px 4px; padding: 14px; border-radius: 14px; border: 1px solid rgba(27,39,83,.12); background: #f5f2ec; font-family: inherit; text-align: left; }',
      pre + '.' + c + '__t { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin: 0; font-size: 14px; font-weight: 700; color: #161a24; line-height: 1.25; }',
      pre + '.' + c + '__pill { font-size: 10.5px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: #fff; background: #1b2753; padding: 4px 8px; border-radius: 999px; }',
      pre + '.' + c + '__d { margin: 2px 0 10px; font-size: 12px; line-height: 1.4; color: #5d6170; }',
      pre + '.' + c + '__item { display: flex; align-items: center; gap: 12px; background: #fff; border: 1px solid rgba(27,39,83,.08); border-radius: 12px; padding: 10px; }',
      pre + '.' + c + '__img { flex: 0 0 56px; width: 56px; height: 56px; display: block; }',
      pre + '.' + c + '__img img { width: 56px; height: 56px; object-fit: cover; border-radius: 10px; background: #fff; display: block; }',
      pre + '.' + c + '__info { flex: 1 1 auto; min-width: 0; }',
      pre + '.' + c + '__name { margin: 0 0 2px; font-size: 13px; font-weight: 700; line-height: 1.3; color: #161a24; }',
      pre + '.' + c + '__name a { color: inherit; text-decoration: none; }',
      pre + '.' + c + '__price { margin: 0; display: flex; flex-wrap: wrap; gap: 6px; font-size: 13px; font-weight: 500; line-height: 16px; }',
      pre + '.' + c + '__price strong { font-weight: 700; color: #1b2753; }',
      pre + '.' + c + '__price s { color: #8a8f9c; }',
      pre + '.utk-vh { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }',
      pre + '.' + c + ' .' + c + '__btn { appearance: none; border: 0; cursor: pointer; font: inherit; flex: 0 0 auto; font-size: 13px; font-weight: 600; line-height: 24px; color: #fff; background: #1b2753; padding: 9px 16px; border-radius: 999px; white-space: nowrap;',
      '  box-shadow: inset 0 1px 0 rgba(255,255,255,.40), inset 0 -1px 0 rgba(0,0,0,.10), 0 1px 2px rgba(27,39,83,.10), 0 6px 16px -8px rgba(27,39,83,.40); transition: transform .25s cubic-bezier(.2,.8,.2,1), box-shadow .25s cubic-bezier(.2,.8,.2,1); }',
      '@media (hover: hover) { ' + pre + '.' + c + ' .' + c + '__btn:hover { transform: translateY(-1px); box-shadow: inset 0 1px 0 rgba(255,255,255,.45), inset 0 -1px 0 rgba(0,0,0,.10), 0 2px 4px rgba(27,39,83,.10), 0 10px 22px -10px rgba(27,39,83,.45); } }',
      pre + '.' + c + ' .' + c + '__btn[disabled] { opacity: .7; cursor: default; transform: none; }',
      '@media (prefers-reduced-motion: reduce) { ' + pre + '.' + c + ' .' + c + '__btn { transition: none; } }',
      /* phones: photo stays on the left, name/price/button stack in the right column (as the tape card does) */
      '@media (max-width: 420px) { ' + pre + '.' + c + '__item { display: grid; grid-template-columns: 56px 1fr; column-gap: 12px; row-gap: 14px; align-items: center; }',
      '  ' + pre + '.' + c + '__img { grid-row: 1 / span 2; } ' + pre + '.' + c + ' .' + c + '__btn { grid-column: 2; width: 100%; } }'
    ].join('\n');
  }

  /* ---------- 1. Supercart drawer ---------- */
  var DRAWER_CSS = cardCSS('utk-sc', '#supercart ') + '\n#supercart .utk-sc--empty { margin-top: 0; }';

  function cardHTML(cls) {
    return '<div class="' + cls + '" data-utk-card>' +
      '<p class="' + cls + '__t"><span class="' + cls + '__pill">New to URSA</span>Try the Test It Kit - ' + esc(C.price) + '!</p>' +
      '<p class="' + cls + '__d">28 pieces from 10 lav accessories. Find your favourites before you stock up.</p>' +
      '<div class="' + cls + '__item">' +
      (C.img ? '<a class="' + cls + '__img" href="' + esc(C.url) + '" tabindex="-1" aria-hidden="true"><img alt="" width="56" height="56" loading="lazy" src="' + esc(C.img) + '"></a>' : '') +
      '<div class="' + cls + '__info"><p class="' + cls + '__name"><a href="' + esc(C.url) + '">URSA Test It Kit</a></p>' +
      '<p class="' + cls + '__price">' + priceHTML() + '</p></div>' +
      '<button type="button" class="' + cls + '__btn" data-utk-card-add>' + btnLabel() + '</button></div></div>';
  }

  var sc = null;
  function drawer() {
    var host = document.querySelector('super-cart');
    if (!host || !host.shadowRoot) return false;
    var root = host.shadowRoot;
    if (!root.__utk) {
      root.__utk = true;
      try { var s = new CSSStyleSheet(); s.replaceSync(DRAWER_CSS); root.adoptedStyleSheets = root.adoptedStyleSheets.concat([s]); }
      catch (e) { var st = document.createElement('style'); st.textContent = DRAWER_CSS; root.appendChild(st); }
      root.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-utk-card-add]'); if (!b) return;
        e.preventDefault(); e.stopPropagation();
        b.disabled = true; b.textContent = 'Adding…';
        add().then(function (ok) { if (!ok) { b.disabled = false; b.innerHTML = btnLabel(); } });
      });
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { readCart().then(placeDrawer); }, 150); })
        .observe(root, { childList: true, subtree: true });
    }
    sc = root;
    placeDrawer();
    return true;
  }
  function placeDrawer() {
    var root = sc; if (!root) return;
    var card = root.querySelector('[data-utk-card]');
    if (!showCard()) { if (card) card.remove(); return; }
    var all = root.querySelectorAll('.supercart-promos'), promos = all.length ? all[all.length - 1] : null; // below the items, above "You may also like"
    var scroll = root.querySelector('section.super-scroll');
    var empty = scroll && scroll.querySelector('h2') && /empty/i.test(scroll.querySelector('h2').textContent) ? scroll.querySelector('h2').parentNode : null;
    var cls = 'utk-sc' + (empty ? ' utk-sc--empty' : '');
    if (card && card.className !== cls) { card.remove(); card = null; }
    if (card) {
      if (promos && card.nextElementSibling === promos) return;
      if (!promos && empty && card.previousElementSibling === empty) return;
      if (!promos && !empty && card.parentNode === scroll) return;
      card.remove();
    }
    var wrap = document.createElement('div'); wrap.innerHTML = cardHTML('utk-sc'); card = wrap.firstChild; card.className = cls;
    if (promos) promos.parentNode.insertBefore(card, promos);
    else if (empty) empty.insertAdjacentElement('afterend', card);
    else if (scroll) scroll.appendChild(card);
  }

  /* ---------- 2. /cart page ----------
     20 Oct 2026 (W26): the card is rendered by snippets/ursa-tik-cartcard.liquid and styled in ursa-test-it-kit.css,
     so it is there at first paint (it used to be added here after /cart.js loaded and pushed the total down).
     This only removes it once the kit is in the basket, and handles the button (delegated, so it survives
     the cart section re-rendering itself). */
  var cartWired = false;
  function cartPage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var card = document.querySelector('.utk-cartcard');
    if (card && !showCard()) card.remove();
    if (cartWired) return; cartWired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.utk-cartcard [data-utk-card-add]'); if (!b) return;
      b.disabled = true; b.textContent = 'Adding…';
      add().then(function (ok) { if (ok) location.reload(); else { b.disabled = false; b.textContent = btnLabel(); } });
    });
  }

  /* ---------- 3. Homepage band ---------- */
  function bands() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-utk-add]'), function (b) {
      var label = b.querySelector('[data-utk-label]');
      if (!b.__utkBase) b.__utkBase = label.innerHTML;
      if (inCart) { label.textContent = 'In your basket. View basket'; b.classList.add('is-added'); }
      else { label.innerHTML = b.__utkBase; b.classList.remove('is-added'); }
      if (b.__utk) return; b.__utk = true;
      b.addEventListener('click', function () {
        if (inCart) { openBasket(); return; }
        b.disabled = true; label.textContent = 'Adding…';
        add().then(function (ok) {
          b.disabled = false;
          if (!ok) { label.innerHTML = b.__utkBase; return; }
          setTimeout(openBasket, 250);
        });
      });
    });
  }

  function syncAll() { placeDrawer(); cartPage(); bands(); }

  function start() {
    readCart().then(function () {
      bands(); cartPage();
      if (!drawer()) { var n = 0, iv = setInterval(function () { if (drawer() || ++n > 60) clearInterval(iv); }, 500); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
